<template>
  <div>
    <Modal v-model="modal" title="修改密码" :mask-closable='show' :closable='show'>
      <p slot="header" style="color:#333;text-align:center;font-weight:500">
        <span>修改密码</span>
      </p>
      <Form ref="pwdForm" :model="pwdForm" :rules="pwdRules" :label-width="100">
        <FormItem label="原密码" prop="passwd" v-if="show">
          <Input v-model="pwdForm.passwd"></Input>
        </FormItem>
        <FormItem label="新密码" prop="password">
          <Input type="password" v-model="pwdForm.password" placeholder="请输入新密码"></Input>
        </FormItem>
        <FormItem label="确认新密码" prop="passwdCheck">
          <Input type="password" v-model="pwdForm.passwdCheck" placeholder="请确认新密码"></Input>
          <Icon type="md-alert" />密码不能少于8位,且必须有数字字母组合
        </FormItem>
      </Form>
      <div slot="footer" class="modal_footer">
        <Button type="primary" @click="handleSubmit">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { validatePassword } from '@/utils/valide.js'
import { forgetPwdUpdate,changepwd } from '@/api/api'
export default {
  name:'changePwd',
  props:{
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (value === this.pwdForm.passwd) {
          callback(new Error('新密码不能与原密码相同!'))
        }
        if (this.pwdForm.passwdCheck !== '') {
          this.$refs.pwdForm.validateField('passwdCheck');
        }
        callback();
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认新密码'));
      } else if (value !== this.pwdForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    return {
      modal:false,
      pwdForm: {
        passwd: '',
        password: '',
        passwdCheck: ''
      },
      pwdRules: {
        passwd: { required: true, message: '请输入原密码', trigger: 'blur' },
        password: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        passwdCheck: { required: true, validator: validatePassCheck, trigger: 'blur' }
      }
    }
  },
  methods: {
    handleSubmit () {
      this.modal = false
      this.$refs['pwdForm'].validate((valid) => {
        if (valid) {
          const query = {
            oldPassword:window.btoa(this.pwdForm.passwd),
            newPassword:window.btoa(this.pwdForm.password)
          }
          if(this.show) {
            changepwd(query).then(res => {
              this.$Message.success('修改成功，即将跳转登录页面!')
              this.$router.push('/login')
            }).catch(err => console.log(err))
          }else {
            forgetPwdUpdate(query).then(res => {
              this.$Message.success('修改成功，请用新密码登录!')
              this.$router.push('/login')
            }).catch(err => console.log(err))
          }
        } else {
          this.$Message.error('修改失败!')
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
  ::v-deep.ivu-modal-body {
    display: flex;
    justify-content: center;
    .ivu-form {
      width: 80%;
    }
  }
</style>